/**
 * Module mapping for permissions
 * Maps module labels to sidebar IDs
 */
export const RESOURCES = {
    DASHBOARD: 1,
    USERS: 2,
    WORKOUTS: 3,
    PROGRAMS: 4,
    SUBSCRIPTIONS: 5,
    BADGES: 6,
    CATEGORIES: 7,
    REVENUE: 8,
    COUPONS: 9,
    NOTIFICATIONS: 10,
    REPORTS_ANALYTICS: 11,
    SUBADMIN: 12,
    COMMUNITY: 13,
    CMS: 14,
    SETTINGS: 15
} as const;

export interface ModuleItem {
    id: number;
    label: string;
}

export const MODULE_LIST: ModuleItem[] = [
    { id: RESOURCES.DASHBOARD, label: "Dashboard" },
    { id: RESOURCES.USERS, label: "Manage Users" },
    { id: RESOURCES.WORKOUTS, label: "Workout management" },
    { id: RESOURCES.PROGRAMS, label: "Manage Programs" },
    { id: RESOURCES.SUBSCRIPTIONS, label: "Subscription" },
    { id: RESOURCES.BADGES, label: "Achievements & Badges" },
    { id: RESOURCES.CATEGORIES, label: "Categories" },
    { id: RESOURCES.REVENUE, label: "Revenue Management" },
    { id: RESOURCES.COUPONS, label: "Discounts and Coupons" },
    { id: RESOURCES.NOTIFICATIONS, label: "Notification Management" },
    { id: RESOURCES.REPORTS_ANALYTICS, label: "Report Analytics" },
    { id: RESOURCES.SUBADMIN, label: "Manage Sub-admin" },
    { id: RESOURCES.COMMUNITY, label: "Community Moderation" },
    { id: RESOURCES.CMS, label: "Manage CMS Pages" },
    // { id: RESOURCES.SETTINGS, label: "System Settings" }, // Commented out - not sending in addRole body
];
